import { useTranslation } from 'react-i18next';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import Checkbox from 'components/Checkbox/Checkbox';
import TextField from 'components/TextField/TextField';
import { NAME_FILTERS, NAME_INPUTS_DEFAULT } from 'constants/dataSets';
import { getFilterIdentifier, getFilterSelectionKey } from 'utils/valueChainHelpers';

import HeaderFilterPanel from './HeaderFilterPanel';

import type { IBoardFilterItem } from 'store/slices/valueChainMap/interfaces/IBoardFilterItem';
import type IFilterListDefault from '../interfaces/IFilterListDefault';

import styles from '../sass/FiltersPanel.module.scss';

function FilterListDefault({
  selectedFilter,
  onBackStepFilter,
  onResetAllCurrent,
  search,
  setSearch,
  filtersData,
  onChange,
  searchFilters,
  selectedCurrentFilters,
}: IFilterListDefault) {
  const { t } = useTranslation();

  const isSelectedFilterItem = (filter: IBoardFilterItem) => selectedCurrentFilters
    .some((selectedFilterItem) => getFilterIdentifier(selectedFilterItem) === getFilterIdentifier(filter)
      && selectedFilterItem.type === selectedFilter);

  const handleShowUniqueIdentifier = (filter: IBoardFilterItem) => {
    if (selectedFilter === NAME_FILTERS.PROFIT_CENTER_LONG) {
      return ` [${filter?.uniqueIdentifier}]`;
    }
    return '';
  };

  return (
    <div className={styles.content}>
      <HeaderFilterPanel
        selectedFilter={t(`common.${selectedFilter}`)}
        onBackStepFilter={onBackStepFilter}
        onResetAllCurrent={onResetAllCurrent}
        ghostButtonTitle={t('common.reset')}
      />
      <div className={styles.searchInputWrapper}>
        {NAME_FILTERS.CONNECTION !== selectedFilter && selectedFilter !== NAME_FILTERS.REVENUE && (
          <TextField
            value={search}
            name={NAME_INPUTS_DEFAULT.SEARCH}
            icon={<SearchIcon />}
            placeholder={t('valueChainMap.search')}
            onChange={({ target }) => setSearch(target.value)}
          />
        )}
      </div>
      <div className={styles.filters}>
        {filtersData && filtersData.length > 0
          ? searchFilters(filtersData, search).map((filter, index) => (
            <div className={styles.filterWrapper} key={[getFilterSelectionKey(filter), index].join('_')}>
              {selectedFilter !== NAME_FILTERS.REVENUE && (
                <Checkbox
                  name={getFilterSelectionKey(filter)}
                  checked={isSelectedFilterItem(filter)}
                  value={String(isSelectedFilterItem(filter))}
                  onChange={onChange}
                  label={(
                    <span>
                      {filter?.name
                        ? `${filter?.name}${handleShowUniqueIdentifier(filter)}`
                        : filter?.type}
                    </span>
                  )}
                />
              )}
            </div>
          )) : null}
      </div>
    </div>
  );
}

export default FilterListDefault;
